








import Vue from 'vue';

export default Vue.extend({
  name: 'icon-bell',
  props: {
    color: {
      type: String,
      required: false,
      default: '#FFFFFF',
    },
  },
});
